module.exports = __webpack_public_path__ + "media/svgs/Tanzfabrik_Signet-green-ce69f2c0e9efb273237bed9df5344e20.svg";